import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 16px;
  margin: 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  ${props => props.theme.isExpanded && `
    margin-bottom: auto;
    color: ${props.theme.bodyColor};
  `};
  a, a:hover {
    color: ${props => props.theme.bodyColor};
  }
`;

const Name = styled.a`
  margin-right: 14px;
  color: ${props => props.theme.bodyColor};
  font-size: 20px;
  text-transform: uppercase;
  ${props => props.theme.isExpanded && `
    font-size: 24px;
    line-height: 26px;
  `};
  ${props => (props.theme.isOnWireSide ? `
    font-size: large;
    margin: 0;
  ` : `
    overflow: hidden;
    text-overflow: ellipsis;
  `)};
`;

export default function Header({
  profile, isExpanded, isOnWireSide, clickDataAttributes,
}) {
  const profileLink = `/contributors/${profile.slug}`;

  const showCompanyName = profile.isCompanyProfile && !!profile.organization;

  return (
    <Container>
      {(!!isOnWireSide || !!isExpanded) && (
        <Name href={profileLink} className="micro-profile-author-name" {...clickDataAttributes}>
          {showCompanyName
            ? (
              <span>
                {profile.organization}
              </span>
            )
            : (
              <span>
                {profile.firstName}
                <br />
                {profile.lastName}
              </span>
            )}
        </Name>
      )}
      {(!isOnWireSide && !isExpanded) && (
        <Name href={profileLink} className="micro-profile-author-name" {...clickDataAttributes}>
          {showCompanyName
            ? (
              <span>
                {profile.organization}
              </span>
            )
            : (
              <span>
                <span>{profile.firstName}</span>
                {' '}
                <span>{profile.lastName}</span>
              </span>
            )}
        </Name>
      )}
    </Container>
  );
}

Header.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    slug: PropTypes.string,
    organization: PropTypes.string,
    isCompanyProfile: PropTypes.bool,
  }).isRequired,
  isExpanded: PropTypes.bool.isRequired,
  isOnWireSide: PropTypes.bool.isRequired,
  clickDataAttributes: PropTypes.shape({}),
};

Header.defaultProps = {
  clickDataAttributes: null,
};
